function e(e,n,t){window.customElements.get(e)||window.customElements.define(e,n,t)}export{e as safeDefine};
